import type { Sale } from '@src/domains/sales/types/sale';
import { getServiceFeeDescriptions } from '@src/domains/service-fees';

export const getSaleServiceFeeDescriptions = (sale: Sale | null | undefined): string[] =>
  getServiceFeeDescriptions(sale?.items ?? []);
